import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function usePageTitle(key) {
  const { t, i18n } = useTranslation();

  const updateTitle = () => {
    document.title = t(key) + ' | ABMFY';
  };

  useEffect(() => {
    updateTitle(); // initial set

    const handleLanguageChange = () => updateTitle();
    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n, key, t]);
}